import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Margin, Size, VerticalGrow } from '../types/type';

@Component({
  selector: 'custom-textarea',
  templateUrl: './custom-textarea.component.html',
  styleUrls: ['./custom-textarea.component.scss']
})
export class CustomTextareaComponent implements OnInit {
  @Input() label: string;
  @Input() helperText: string;
  @Input() placeholder: string;
  @Input() id: string;
  @Input() disabled: boolean;
  @Input() required: boolean = false;
  @Input() value;
  @Input() margin: Margin = 'medium';
  @Input() size: Size ;
  @Input() verticalGrow: VerticalGrow ;
  @Input() errorMessage;
  @Input() maxLength;
  @Input() minLength;
  @Input() rows;
  @Input() columns;
  @Output() valueChange = new EventEmitter<any>();
  @Output() blur = new EventEmitter<any>();

  constructor() {
    //Constructor
  }

  ngOnInit(): void {
    //onInit
  }
  onChange(event) {
    this.valueChange.emit(event.value);
  }

  onBlur(event) {
    this.blur.emit(event);
  }
}
